import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { Col, Row } from 'reactstrap';

import CollapsibleCard from 'app/components/common/CollapsibleCard';
import { getPaymentMethodLabel } from 'utils/orders';
import { currency } from 'globals/currency';
import { fixDecimal } from 'utils/general';
import OrderDelivery from '../orders/order-parts/OrderDelivery';
import OrderPaymentType from '../orders/order-parts/OrderPaymentType';
import OrderTotal from '../orders/order-parts/OrderTotal';
import PromoCodeText from '../orders/PromoCodeText';
import OrderSource from '../orders/order-parts/OrderSource';

class OrdersHistory extends React.Component<{ data: any }, {}> {
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  render() {
    const { data: statisticsData } = this.props;
    return Object.entries(statisticsData.statsByDay || {}).map(
      ([date, item]) => (
        <React.Fragment key={date}>
          {this.renderOrdersCard(date, item)}
          {this.renderDeliveriesCard(date, item)}
        </React.Fragment>
      )
    );
  }

  renderOrdersCard(date, item) {
    if (!item.orders || !item.orders.length) {
      return null;
    }
    return (
      <CollapsibleCard
        title={i18next.t('orders-history.orders-card-title', {
          date,
          count: item.orders_count,
          sum: fixDecimal(item.orders_sum),
          currency,
          payout: item.payout_amount,
        })}
        className="mt-3"
      >
        {item.orders.map((order) => (
          <Row key={order.id} className="bt-grey-1">
            <Col>
              <div>
                {i18next.t('order.title')} #{order.id}: {order.created_at}
              </div>
              <OrderDelivery order={order} />
              <OrderPaymentType order={order} />
              <OrderSource order={order} />
            </Col>
            <Col>
              <PromoCodeText order={order} />
              {order.products.map(this.renderProductRow)}
              <OrderTotal order={order} />
            </Col>
          </Row>
        ))}
      </CollapsibleCard>
    );
  }

  renderProductRow = (product) => {
    const hasDiscount = !!product.discountAmount;
    const fullPrice = fixDecimal(product.amount * product.price);
    const discountPart = hasDiscount
      ? i18next.t('orders-history.product-with-discount', { fullPrice, discountAmount: product.discountAmount })
      : null;
    const pricePart = hasDiscount
      ? fixDecimal(product.amount * product.price - product.discountAmount)
      : fullPrice;
    return (
      <div key={product.name}>
        {product.amount} x {product.name}: {pricePart} {currency} {discountPart}
      </div>
    );
  };

  renderDeliveriesCard(date, item) {
    if (!item.deliveries || !item.deliveries.length) {
      return null;
    }
    return (
      <CollapsibleCard
        title={i18next.t('orders-history.deliveries-card-title', { date, count: item.deliveries.length })}
      >
        {item.deliveries.map((delivery) => (
          <Row key={delivery.id}>
            <Col>
              {
                delivery.type === 'internal'
                  ? i18next.t('orders-history.internal-delivery', { id: delivery.id, orderId: delivery.order_id })
                  : i18next.t('orders-history.external-delivery', {
                      id: delivery.id,
                      address: delivery.address,
                      price: delivery.price,
                      currency,
                      paymentMethod: i18next.t(
                        `payment-types.${getPaymentMethodLabel(delivery.payment_status)}`
                      ),
                    }) /* TODO probably should use payment_type */
              }
            </Col>
          </Row>
        ))}
      </CollapsibleCard>
    );
  }
}

export default OrdersHistory;
